import React, { Fragment } from "react";
import { FaDownload } from "react-icons/fa6";
import { HiArrowNarrowRight } from "react-icons/hi";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import Comments from "../Comments/Comments";
import Header from "../../../utils/Header/Header";
import Layout from "../../../utils/Layouts/Layout/Layout";
import bannerImg from "../../../assets/tetgeleg_banner.png";
import bannerImg2 from "../../../assets/tetgeleg_image.png";
import pdfFile from "../../../assets/Тэтгэлэг.pdf";

const ScholarshipComponent = () => {
  const [open, setOpen] = React.useState(false);
  const formUrl = "https://docs.google.com/forms/d/e/1FAIpQLSdk3Lq9I0SOI9hSNDm6ih_csbmjcxC3V7rIU9kQQFFeKzPEYw/viewform?usp=dialog";

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Layout>
        <Header onHome={true} />
        {
          <section className="news-hero">
            <img
              className="news-hero__image"
              src={bannerImg}
              alt="banner"
            />
          </section>
        }
        <Fragment>

          <div className="text-white lg:px-32 md:px-20 px-6 pt-20 pb-16 text-[18px] bg-[#071949]">
            <div className="flex gap-12 mb-16 md:flex-row flex-col">
              <div className="xl:flex-[.3] md:flex-[.5] 2xl:text-[70px] xl:text-[56px] md:text-[40px] text-[28px] font-semibold xl:leading-34 text-center">
                Тэтгэлэгт хөтөлбөр 2025-2026
              </div>
              <div className="flex-[.5] lg:px-20 md:px-8 flex flex-col justify-center gap-12">
                <div className="text-gray-300 text-[18px] md:text-start text-center">
                  Эдийн засаг, санхүүгийн чиглэлээр суралцаж буй 2 - оос 4-р
                  дамжааны оюутнууд хамрагдана. Ирээдүйд олон улсын санхүүгийн
                  зах зээлд өрсөлдөх чин хүсэл эрмэлзэлтэй, эх оронч иргэнийг
                  дэмжихэд оршино.
                </div>
                <a
                  href={pdfFile}
                  download="tetgeleg-udirdamj.pdf"
                  className="flex md:flex-none flex-1 justify-center rounded-full border-[1px] text-white border-gray-300 items-center px-12 py-4 gap-6 select-none cursor-pointer font-semibold hover:bg-white hover:text-black hover:border-black"
                >
                  <div>Тэтгэлэгийн удирдамж татах</div>
                  <FaDownload />
                </a>
              </div>
            </div>
            <div className="flex gap-10 mb-8 md:flex-row flex-col">
              <div className="xl:flex-[.3] md:flex-[.5] overflow-hidden rounded-4xl">
                <img
                  src={bannerImg2}
                  alt=""
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="flex-[.7] text-gray-300 flex flex-col gap-3">
                <div className="font-semibold text-[24px] mb-4">
                  Тэтгэлэгийн хэмжээ:
                </div>
                <div>- 1,000,000 төгрөг</div>
                <div>
                  - 1,700,000 төгрөгийн үнэ бүхий Олон улсын вальютийн зах зээлийн
                  онлайн сургалтын эрх
                </div>
                <div className="font-semibold text-[24px] mt-8 mb-4">
                  Тэтгэлэг хүсэгчид тавигдах үндсэн шалгуур:
                </div>
                <div>
                  - Монгол улсын магадлан итгэмжлэгдсэн их, дээд сургуулийн
                  бакалаврын зэргийн 2, 3, 4-р курсын оюутан байх
                </div>
                <div>
                  - Сурах хүсэл эрмэлзэлтэй, анги хамт олноо сурлагын амжилтаар
                  тэргүүлэгч байх
                </div>
                <div>- 3.2 ба түүнээс дээш голчтой</div>
                <div>- Өрхийн орлого харгалзан үзнэ</div>
                <div className="flex mt-12">
                  <div
                    className="flex flex-1 md:flex-none justify-center rounded-full border-[1px] border-gray-300 items-center px-12 py-4 gap-6 select-none cursor-pointer font-semibold hover:bg-white hover:text-black hover:border-black"
                    onClick={() => window.open(formUrl, "_blank")}
                  >
                    <div>Тэтгэлэгт хүсэлт өгөх</div>
                    <HiArrowNarrowRight />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="text-center text-white md:text-[32px] text-[24px] uppercase md:pt-16 pt-10 md:pb-12 pb-6 font-semibold bg-[#00000033]">
            <h3 className="">Сэтгэгдэлүүд</h3>
          </div>
          <Comments /> */}
        </Fragment>
      </Layout>
    </>
  );
};

export default ScholarshipComponent;
